import { Injectable } from '@angular/core';
import { AbstractUndoManager } from '../../cross-team-shared/state/abstract-undo-manager';
import { CameraState } from './camera-state';
import { PointCloudContentState } from './point-cloud-content-state';
import { PointCloudContentStore } from './point-cloud-content-store';

interface UndoState {
  camera: CameraState;
}

/**
 * PointCloudContentStateUndoService is responsible for updating the PointCloudContentState
 * after an undo or a redo and setting that state to the PointCloudContentStore
 */
@Injectable()
export class PointCloudContentStateUndoService extends AbstractUndoManager<
  PointCloudContentState,
  UndoState
> {
  constructor(store: PointCloudContentStore) {
    super(store);
  }

  protected applyUndoState(stateToApply: UndoState) {
    this.store('camera').assign(stateToApply.camera);
  }

  protected extractUndoState(state: PointCloudContentState) {
    return { camera: state.camera };
  }

  protected hasTrackedChanges() {
    return false;
  }
}
